import { InputNumber } from "primereact/inputnumber";
import { Controller } from "react-hook-form";
import styles from "../../style.module.scss";

const FormNumberField = ({
    name, control, errors, required = false, disabled = false,
    label = "", placeholder = "", minFractionDigits = 0,
    maxFractionDigits = 2,
}) => (
    <div className={`p-d-flex p-flex-column ${styles.formFieldContainer}`}>
        {label !== "" && <label className={required ? styles.requiredLabel : ""} htmlFor={name}>{label}</label>}
        <Controller name={name}
                    control={control}
                    rules={required ? {required: "Поле обязательно для заполнения"} : undefined}
                    render={({ field }) => {
                        const hasValue = field.value != null && field.value !== "";

                        return (
                            <div className={styles.inputWithClear}>
                                <InputNumber
                                    id={name}
                                    value={field.value}
                                    onValueChange={(e) => field.onChange(e.value)}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    useGrouping={false}
                                    mode="decimal"
                                    step={1 / Math.pow(10, maxFractionDigits)}
                                    minFractionDigits={minFractionDigits}
                                    maxFractionDigits={maxFractionDigits}
                                    className={errors[name] ? "p-invalid" : undefined}
                                    inputClassName={errors[name] ? "p-invalid" : undefined}
                                />
                                {hasValue && !disabled && (
                                    <button
                                        type="button"
                                        className={styles.clearButton}
                                        onClick={() => field.onChange(null)}
                                        aria-label="Очистить поле"
                                    >
                                        <i className="pi pi-times"></i>
                                    </button>
                                )}
                            </div>
                        );
                    }}
        />
        {errors[name] && <small className="p-error">{errors[name].message}</small>}
    </div>
);

export default FormNumberField;